<template>
  <div class="deliverable-projects" v-if="deliverable">
    <template v-if="!disabled">
      <div class="pb-0 titles exclude-outside-click" v-if="!addProjectFlag">
        <div
          class="department-title exclude-outside-click"
          :class="canEditDeliverableProject(deliverable.project_id) ? '' : 'pointer-default'"
          :key="'deliverable-modal-department-'+deliverable.project_id.id"
          v-if="deliverable.project_id"
          @click="goToProject(deliverable.project_id.id)"
        >
        {{ deliverable.project_id.name }}
        <span
          v-if="deliverable.project_id.project_status && deliverable.project_id.project_status.slug && deliverable.project_id.project_status.slug=='on-hold'">
          : 
          {{ deliverable.project_id.project_status.name }}
        </span>
        </div>
        <div @click="showAddProject()" class="department-title exclude-outside-click" v-if="!deliverable.project_id  && getDeliverableTemplateSlug(deliverable.deliverable_template_id) != 'social-media'">No Project</div>
        <button @click="showAddProject()" v-if="canEditDeliverableProject(deliverable.project_id)  && getDeliverableTemplateSlug(deliverable.deliverable_template_id) != 'social-media'" type="button" class="plus-button plus-button--small exclude-outside-click">
          <img class="exclude-outside-click" src="@/csmworkflow/img/pencil.svg" />
        </button>
      </div>
      <multiselect
        ref="deliverableProjects"
        v-click-outside="outside"
        v-if="addProjectFlag"
        v-model="deliverable.project_id"
        :close-on-select="true"
        :options="projectsOption"
        :show-labels="false"
        :multiple="false"
        :taggable="false"
        label="name"
        track-by="id"
        :id="deliverable.deliverableId"
        @input="setDeliverableProject(deliverable)"
        @close="addProjectFlag=false"
      ></multiselect>
    </template>
    <template v-else>
      <div class="pb-0 titles exclude-outside-click">
      	<div
      	  class="department-title exclude-outside-click"
      	  :class="canEditDeliverableProject(deliverable.project_id) ? '' : 'pointer-default'"
      	  :key="'deliverable-modal-department-'+deliverable.project_id.id"
      	  v-if="deliverable.project_id"
      	  @click="goToProject(deliverable.project_id.id)"
      	>
      	  {{ deliverable.project_id.name }}
          <span 
            v-if="deliverable.project_id.project_status && deliverable.project_id.project_status.slug && deliverable.project_id.project_status.slug=='on-hold'">
            ({{ deliverable.project_id.project_status.name }})
          </span>
      	</div>
        <div class="department-title exclude-outside-click" v-if="!deliverable.project_id">No Project</div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import toast from "../../toast";

export default {
  props: ["deliverable","disabled", "namespace"],
  data() {
    return {
      addProjectFlag: false
    };
  },
  computed: {
  	...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  allProjects (state, getters) {
  	    return getters['allProjects']
  	  },
  	  userAbilities (state, getters) {
  	    return getters['userAbilities']
  	  },
  	  userManageProjects (state, getters) {
  	    return getters['userManageProjects']
  	  },
  	  getDeliverableTemplateSlug (state, getters) {
  	    return getters['getDeliverableTemplateSlug']
  	  },
  	}),
    projectsOption() {
      if (this.userAbilities.accessAllProjects) {
        if(this.allProjects) {
          let projectArr = [];
          this.allProjects.forEach(elem => {
            projectArr.push({id: elem.id, name: elem.title, engagement_manager: elem.engagement_manager, project_lead: elem.project_lead});
          });
          return projectArr;
        }
      } else {
        if(this.userManageProjects) {
          let projectArr = [];
          this.userManageProjects.forEach(elem => {
            projectArr.push({id: elem.id, name: elem.title, engagement_manager: elem.engagement_manager, project_lead: elem.project_lead});
          });
          return projectArr;
        }
      }
    },
    hasProjectOption() {
      return this.projectsOption && this.projectsOption.length > 0;
    },
  },
  methods: {
  	...mapActions({
  	  setDeliverableProject (dispatch, payload) {
  	    return dispatch(this.namespace + 'setDeliverableProject', payload)
  	  },
  	  fetchProjects (dispatch, payload) {
  	    return dispatch(this.namespace + 'fetchProjects', payload)
  	  },
  	  fetchUserManageProjects (dispatch, payload) {
  	    return dispatch(this.namespace + 'fetchUserManageProjects', payload)
  	  },
  	  fetchProjectDeliverableById (dispatch, payload) {
  	    return dispatch(this.namespace + 'fetchProjectDeliverableById', payload)
  	  },
  	  getProjectNumberFromId (dispatch, payload) {
  	    return dispatch(this.namespace + 'getProjectNumberFromId', payload)
  	  },
  	  fetchAllProjects (dispatch, payload) {
  	    return dispatch(this.namespace + 'fetchAllProjects', payload)
  	  },
  	}),
  	...mapMutations({
  	  setDataLoading (commit, payload) {
  	    return commit(this.namespace + 'setDataLoading', payload)
  	  },
  	}),
    showAddProject() {
     if (this.userAbilities.accessAllProjects) {
      this.fetchAllProjects()
     }

      if(!this.canEditDeliverableProject(this.deliverable.project_id)) return;
      if(!this.userAbilities.editMediaCall || this.deliverable.permissions.viewOnly) return;
      this.addProjectFlag = true
      this.$nextTick(() => {
        this.$refs.deliverableProjects.$el.focus()
      })
    },
    outside() {
      this.$set(this, "addProjectFlag", false);
    },
    userCanEditProject(project) {
      if (!project) return false;

      const userId = localStorage.getItem("userId");

			if (this.userAbilities.accessAllProjects) {
				return this.userAbilities.editProject;
			}

			let isManager = false;
			if (project.engagement_manager instanceof Object) {
				isManager = userId == project.engagement_manager.id;
			} else {
				isManager = userId == project.engagement_manager;
			}

			return (this.userAbilities.editProject && isManager);
    },
    canEditDeliverableProject(project) {
      if (this.userAbilities.accessAllProjects) return true;
      if (!this.hasProjectOption) return false;

      const userId = localStorage.getItem("userId");
      let isManager = false;
      if (project) {
        if (project.engagement_manager instanceof Object && project.project_lead instanceof Object) {
          isManager = userId == project.engagement_manager.id || userId == project.project_lead.id;
        } else {
          isManager = userId == project.engagement_manager || userId == project.project_lead;
        }
      } else {
        isManager = true;
      }

      return (this.userAbilities.editMediaCall && isManager);
    },

    goToProject(projectId) {
      this.setDataLoading(true);
      this.getProjectNumberFromId(projectId).then((projectNumber) => {
        this.fetchProjectDeliverableById(projectNumber).then(() => {
          this.setDataLoading(false);
          const isNumber = !isNaN(Number(projectNumber));
          if (isNumber) {
            this.$router.push(`/project/${projectNumber}`);
          } else {
            toast.error('Invalid project.');
          }
        });
      })
		},
  },
};
</script>

<style lang="scss">
.parent-project-on-hold .deliverable-projects .department-title {
  font-weight: 600 !important;
}
</style>
